import {MuWidget} from "mu-widget/lib/MuWidget";
import {getDocumentName, UiDms} from "./UiDms";
import {DmsDocument} from "./Types";

export class UiDmsHistory extends MuWidget
{
	beforeIndex() {
		this.container.classList.add('dms-history');
		this.muAppendContent(`
			<div mu-id="items" mu-bind="items:@foreach">
				<div mu-template="item" mu-widget="." class="dms-history__item">
					<div class="dms-history__item-head">
						<span mu-bind="account"></span> v <span mu-bind="dtOperation"></span>
					</div>
					<table class="table table-hover table-striped table-sticky-header">
						<thead><tr><th>Parametr</th><th>Stará hodnota</th><th>Nová hodnota</th></tr></thead>
						<tbody mu-bind="changes:@foreach">
							<tr mu-template="item" mu-widget=".">
								<td mu-bind="fieldName"></td>
								<td mu-bind="oldValue"></td>
								<td mu-bind="newValue"></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		`);
	}

	public async loadForDocument(document: DmsDocument)
	{
		this.ui.modalTitle.innerText = "Historie dokumentu " + getDocumentName(document.evidenceUid);
		const data = await UiDms.instance.cl.getDocumentHistory(document.id);
		console.log(data);
		this.muBindData({items: data});
	}
}